import { connect } from "react-redux";

import Verbundsteuerung from "./Verbundsteuerung";

export default connect(state => ({
	compressors: state.ablauf.compressors
}))(Verbundsteuerung);
